// extracted by mini-css-extract-plugin
export var avatarBone = "_4-4";
export var buttonBone = "_4-3";
export var continueBone = "_4-a";
export var frame = "_4-1";
export var logoBone = "_4-2";
export var pickerGrid = "_4-d";
export var pitchBone = "_4-9";
export var productBone = "_4-8";
export var sectionBone = "_4-7";
export var shell = "_4-0";
export var skeletonPulse = "_4-b";
export var subtitleBone = "_4-6";
export var titleBone = "_4-5";
export var viewport = "_4-c";